import { useEffect, useState } from "react";
import { api } from "../../services/api";
import "./operatorselector.css";
import "../../global.css";

const fetchOperatorData = async (token, includeTestMode) => {


  const params = new URLSearchParams();
  params.append("includeTestMode", includeTestMode ? "true" : "false");
  const response = await api.get(`/api/bookingsreport/operators?${params.toString()}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

const OperatorSelector = ({ operators, setOperators, onSelect }) => {
  const [selected, setSelected] = useState("");
  const [includeTestMode, setIncludeTestMode] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      setLoading(true);
      fetchOperatorData(token, includeTestMode)
        .then(data => {
          setOperators(data);
          // If only one operator, auto-select it
          if (data.length === 1) {
            setSelected(data[0].operatorId);
            if (onSelect) onSelect(data[0].operatorId);
          } else {
            setSelected("");
            if (onSelect) onSelect("");
          }
        })
        .catch(error => console.error(error))
        .finally(() => setLoading(false));
    }
  }, [includeTestMode, onSelect, setOperators]);

  const handleChange = (e) => {
    const value = e.target.value;
    setSelected(value);
    // Always call onSelect to handle deselection 
    if (onSelect) onSelect(value);
  };

  const handleTestModeChange = (e) => {
    setIncludeTestMode(e.target.checked);
  };

  return (
    <div className="operator-selector-row">
      <label style={{ marginRight: "1rem", display: "flex", alignItems: "center" }}>
        <input
          type="checkbox"
          checked={includeTestMode}
          onChange={handleTestModeChange}
          style={{ marginRight: "0.5rem" }}
          disabled={loading}
        />
        Include Test Mode
      </label>
      <select className="operator-selector-dropdown"
        value={selected} onChange={handleChange} disabled={operators.length === 0}>
        <option value="">-- Select Operator --</option>
        {operators.map(op => (
          <option key={op.operatorId} value={op.operatorId}>
            {op.operatorName}
          </option>
        ))}
      </select>
      <div className="operator-selector-spacer" />
      {loading && (
        <div className="spinner" style={{ marginLeft: "2rem", width: "32px", height: "32px" }} />
      )}
    </div>
  );
};

export default OperatorSelector;